import { useBillingContextQuery } from '@/hooks/queries/use-billing-context-query';
import { metaPixel } from '@/libs/meta-pixel';
import { takeSubscriptionConversion } from '@/libs/meta-pixel-subscription';
import { useEffect } from 'react';

/** Reports to Meta, once, the plan this browser started as soon as it reads active. */
export function MetaSubscriptionConversion() {
  const { data: context } = useBillingContextQuery();

  useEffect(() => {
    if (!context) return;
    const conversion = takeSubscriptionConversion(context);
    if (conversion) metaPixel.track(conversion.event, conversion.params, conversion.eventId);
  }, [context]);

  return null;
}
